<app-input-label
    [label]="label"
    [labelPosition]="labelPosition"
    [for]="id"
    [isRequired]="isRequired"
    [isEditMode]="isEditMode">
    @if (isEditMode) {
        <kendo-datepicker
            [ngClass]="generateInputStyle()"
            [id]="id"
            [adaptiveTitle]="title | translate"
            [placeholder]="placeholder"
            [format]="format || defaultDateFormat"
            [formatPlaceholder]="formatPlaceholder"
            [navigation]="false"
            [required]="isRequired"
            [max]="maxDate"
            [min]="minDate"
            [disabled]="isDisabled"
            [disabledDates]="disabledDates"
            [ngModel]="dateValue()"
            (valueChange)="onValueChange($event)"
            (focusin)="onFocusIn()"
            (focusout)="onFocusOut()">
            <kendo-datepicker-messages [today]="'Today' | translate" />
        </kendo-datepicker>
        <app-input-error [error]="error()?.[0]" />
    } @else {
        <div class="w-full truncate pt-1.5 pb-1">
            <span kendoTooltip [title]="dateValue() | customDate">
                {{ value() | customDate }}
            </span>
        </div>
    }
</app-input-label>
